import { Route,Routes,useLocation} from 'react-router-dom'
import LoginPage from '../pages/login';
import TabbedLayout from '../components/TabbedLayout';

function Proutes() {

    const location = useLocation();
    return (
      <Routes location={location} key={location.pathname}>
        <Route path='/' exact>
            <Route path='/' element={<LoginPage/>}/>
        </Route>

        {/* Single-window tabbed layout - all modules handled inside */}
        <Route path='/dashboard' element={<TabbedLayout />}/>
      </Routes>
  )
}

export default Proutes